import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/api/client';
import logoCarex from '@/assets/images/logo/logo-carex.svg';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.message || "Erreur lors de l'envoi");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={logoCarex} alt="CAREX" className="h-12 mx-auto mb-3" />
          <p className="text-sm text-slate-500">Réinitialisation du mot de passe</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 space-y-4">
          {sent ? (
            <div className="text-center space-y-3">
              <p className="text-sm text-slate-700">
                Si un compte existe avec cet email, un lien de réinitialisation a été envoyé.
              </p>
              <Link to="/login" className="text-sm text-carex-600 hover:text-carex-700 font-medium">
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">
                  Adresse email
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-carex-500 focus:border-carex-500"
                  placeholder="nom@carex.fr"
                />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                className="w-full py-2 px-4 bg-carex-600 text-white text-sm font-medium rounded-md hover:bg-carex-700 focus:outline-none focus:ring-2 focus:ring-carex-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {submitting ? 'Envoi...' : 'Envoyer le lien'}
              </button>

              <div className="text-center">
                <Link to="/login" className="text-sm text-slate-500 hover:text-slate-700">
                  Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
